import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BeautyBookPost } from '@features/beautybook/interfaces/beautybook.interface';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

const apiUrl = environment.apiUrl + 'user/';

@Injectable({
  providedIn: 'root',
})
export class GuestBeautybookService {
  constructor(private http: HttpClient, private datePipe: DatePipe) {}

  getBeautybookPosts(itemPerPage: number, currentPage: number = 1) {
    return this.http
      .post(apiUrl + 'beauty_book_post/search', {
        item_per_page: itemPerPage,
        current_page: currentPage,
      })
      .pipe(
        map((res: any) => {
          let beautybookPosts: BeautyBookPost[] = res.data.beautybook_posts;

          beautybookPosts.forEach((post) => {
            if (post.created_at)
              post.formatted_created_at =
                this.datePipe.transform(new Date(post.created_at), 'dd MMM') ||
                '';
            if (post.updated_at)
              post.formatted_updated_at =
                this.datePipe.transform(new Date(post.updated_at), 'dd MMM') ||
                '';
          });

          return beautybookPosts;
        })
      )
      .pipe(
        catchError((error) => {
          return throwError(error);
        })
      );
  }
}
